import gql from 'graphql-tag'
import { EnumFields } from '..'

export const QuotaTypeFragment = gql`
  fragment QuotaType on settings_quota_type {
    ${EnumFields}
  }
`
